export default __webpack_public_path__ + "images/assets/d5b0a4626052f665c5796b145d5c4266.svg";